// extracted by mini-css-extract-plugin
module.exports = {"mainPanel":"EditorPreview_mainPanel__2os5V"};